import { Link } from "react-router-dom";
import SectionHead from "../components/SectionHead";
import { Reveal } from "../components/motion";
import { ABOUT_PHOTOS } from "../data/content";
import { useLang } from "../i18n";

const AboutPage = () => {
    const { t } = useLang();
    const a = t.about;

    return (
        <main className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
            <div className="grid items-center gap-12 lg:grid-cols-12">
                <div className="lg:col-span-6">
                    <SectionHead
                        eyebrow={a.eyebrow}
                        title={a.title}
                        testid="about-title"
                    />
                    <Reveal delay={0.1}>
                        <div className="mt-6 space-y-5 text-base leading-relaxed text-[#525B53]">
                            <p>
                                {a.p1a} <strong className="font-semibold text-ink">Irene Infante Riol</strong> {a.p1b}
                            </p>
                            <p>{a.p2}</p>
                            <p>{a.p3}</p>
                        </div>
                    </Reveal>
                </div>
                <Reveal delay={0.15} className="lg:col-span-6">
                    <figure className="relative mx-auto max-w-md lg:max-w-none">
                        <div className="absolute -inset-4 -z-10 rounded-[13rem_13rem_2rem_2rem] bg-sand/70" aria-hidden="true" />
                        <div className="arch-frame overflow-hidden border border-[#E3DCCF] shadow-xl shadow-ink/10">
                            <img
                                src="/images/irene-e.jpeg"
                                alt={a.caption}
                                className="aspect-[4/5] w-full object-cover"
                                loading="eager"
                            />
                        </div>
                        <figcaption className="absolute -bottom-5 left-1/2 w-max -translate-x-1/2 rounded-full border border-[#E3DCCF] bg-white/95 px-5 py-2.5 text-sm font-semibold text-ink shadow-lg backdrop-blur">
                            {a.caption}
                        </figcaption>
                    </figure>
                </Reveal>
            </div>

            <Reveal className="mt-24">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta">{a.galleryEyebrow}</p>
                <h2 className="font-serif mt-3 text-2xl font-semibold tracking-tight text-ink sm:text-3xl">
                    {a.galleryTitle}
                </h2>
            </Reveal>
            <div data-testid="about-gallery" className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
                {ABOUT_PHOTOS.map((photo, i) => (
                    <Reveal key={photo.src} delay={i * 0.08}>
                        <figure className="group">
                            <div className="overflow-hidden rounded-[1.5rem] border border-[#E3DCCF] shadow-sm">
                                <img
                                    src={photo.src}
                                    alt={a.gallery[i] || photo.alt}
                                    loading="lazy"
                                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                            </div>
                            <figcaption className="font-serif mt-3 text-center text-sm italic text-[#525B53]">
                                {a.gallery[i] || photo.alt}
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>

            <div className="mt-20 grid gap-5 md:grid-cols-3">
                {a.blocks.map((block, i) => (
                    <Reveal key={block.title} delay={i * 0.08}>
                        <div className="h-full rounded-[1.5rem] border border-[#E3DCCF] bg-white p-7">
                            <h2 className="font-serif text-xl font-semibold text-terracotta">{block.title}</h2>
                            <p className="mt-3 text-sm leading-relaxed text-[#525B53]">{block.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal className="mt-16 text-center">
                <p className="font-serif text-2xl font-semibold italic text-ink sm:text-3xl">
                    {a.ctaLine}
                </p>
                <Link
                    to="/contacto"
                    data-testid="about-cta"
                    className="mt-7 inline-flex rounded-full bg-terracotta px-8 py-4 text-[15px] font-bold text-cream shadow-lg shadow-terracotta/25 transition-[background-color,transform] duration-200 hover:bg-terracotta-dark hover:-translate-y-0.5"
                >
                    {a.cta}
                </Link>
            </Reveal>
        </main>
    );
};

export default AboutPage;
